<template>
    <article :data-project-id="project.id" class="card">
        <div class="ghost-mask"></div>
        <div class="card-inner">
            <div v-if="false" class="row">
                <div class="col-6">
                    <span class="due-days">-</span>
                </div>
                <div class="col-6">
                    <span class="card-status good warning bad"></span>
                </div>
            </div><!-- /.row -->
            <router-link :to="{ name: 'projects.show.details', params: { project_id: project.id } }" tag="h3">{{ project.title }} <i class="far fa-xs fa-external-link-alt"></i></router-link>
            <div class="row">
                <div class="col-sm-4">
                    <a v-if="false" href="#" class="sub-action">
                        <i class="mi chat"></i> 1
                    </a>
                    <a v-if="false" href="#" class="sub-action">
                        <i class="mi attach_file"></i> 3
                    </a>
                </div>
                <div class="col-sm-8">
                    <ul class="people">
                        <li v-if="false" class="add">
                            <a href="#"><i class="mi add"></i></a>
                        </li>
                        <li>
                            <a href="#">
                                <img class="img-circle" :src="getAvatar(project.project_owner_id)" alt="Name" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div><!-- /.row -->
        </div>
        <div class="card-footer">
            <p class="truncate" :title="project.client.company">{{ project.client.company }}</p>
        </div>
    </article>
</template>

<script>
    import { notify } from 'utils'
    import { user } from 'mixins'

    export default {
        mixins: [user],

        props: ['project'],

        data () {
            return {
                editOwner: false,
            }
        },

        mounted () {
            var that = this

        },

        watch: {
            'project.project_owner_id': function() {
                var that = this

                client({path: '/projects/'+this.project.id, entity: {'project_owner_id': this.project.project_owner_id}, method: 'PUT'}).then(
                    function(response) {

                        var user = that.$store.users.find(function(user) {
                            return user.id == that.project.project_owner_id
                        })

                        that.project.project_owner = response.entity.project_owner
                        that.editOwner = false
                    },
                    function(response) {
                        notify.error('Failed to change project owner')
                    }
                )
            }
        }
    }

</script>
